import { useState, useEffect } from 'react';
import distanceCalculator from '../search/distanceCalculator';
import { priceCalculationNormal, priceCalculationVan } from '../search/priceCalculation';

export default function DynamicPrice({ fromLocation, toLocation, passengers }) {
    const [price, setPrice] = useState('...');

    useEffect(() => {
        let isMounted = true;
        const fetchPrice = async () => {
            try {
                if (!fromLocation || !toLocation) {
                    if (isMounted) setPrice('€0');
                    return;
                }

                const dist = await distanceCalculator(fromLocation, toLocation);

                // Determine car type based on passengers (similar logic as mainForm)
                // If pax >= 5, van. Otherwise normal. But wait, we don't know suitcases from backend, so just pax.
                const carType = passengers >= 5 ? 'van' : 'normal';

                let euros, cents;
                if (carType === 'van') {
                    [euros, cents] = await priceCalculationVan(dist);
                } else {
                    [euros, cents] = await priceCalculationNormal(dist);
                }

                if (isMounted) {
                    setPrice(`€${euros}`);
                }
            } catch (error) {
                console.error("Error calculating dynamic price:", error);
                if (isMounted) setPrice('N/A');
            }
        };

        fetchPrice();

        return () => {
            isMounted = false;
        };
    }, [fromLocation, toLocation, passengers]);

    return (
        <span className="font-black text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md text-sm border border-emerald-100 shadow-sm">{price}</span>
    );
}
